<template>
	<el-form ref="directDebitInformation" :model="directDebitInformation" :rules="rules" label-position="top">
		<el-row :gutter="10">
			<el-col :span="8">
				<el-form-item label="Account Name" prop="account_name">
					<el-input v-model="directDebitInformation.account_name"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="8">
				<el-form-item label="BSB Number" prop="bsb_number">
					<el-input v-model="directDebitInformation.bsb_number" v-mask="'###-###'"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="8">
				<el-form-item label="Account Number" prop="account_number">
					<el-input v-model="directDebitInformation.account_number" v-mask="'########?#'"></el-input>
				</el-form-item>
			</el-col>
		</el-row>
	</el-form>
</template>

<script>
	import { mapGetters } from "vuex"
	import { VueMaskDirective } from "v-mask"

	export default {
		name: "DirectDebit",
		directives: {
			mask: VueMaskDirective,
		},
		data() {

			const validateAccountName = (rule, value, callback) => {
				if (value == "" && (_.get(this.directDebitInformation, 'bsb_number', false) || _.get(this.directDebitInformation, 'account_number', false))) {
					callback(new Error("Account Name is Required"))
				} else {
					callback()
				}
			}

			const validateBsbNumber = (rule, value, callback) => {
				if (value == "" && (_.get(this.directDebitInformation, 'account_name', false) || _.get(this.directDebitInformation, 'account_number', false))) {
					callback(new Error("BSB Number is Required"))
				} else {
					callback()
				}
			}
			const validateAccountNumber = (rule, value, callback) => {
				if (value == "" && (_.get(this.directDebitInformation, 'account_name', false) || _.get(this.directDebitInformation, 'bsb_number', false))) {
					callback(new Error("Account Number is Required"))
				} else {
					callback()
				}
			}

			return {
				saveDelay: 1000,
				saveTimeout: null,
				saveRequest: null,
				defaultDirectDebitInformation: {
					account_name: "",
					bsb_number: "",
					account_number: "",
				},
				rules: {
					account_name: [{ validator: validateAccountName, trigger: "change" }],
					bsb_number: [{ validator: validateBsbNumber, trigger: "change" }],
					account_number: [{ validator: validateAccountNumber, trigger: "change" }],
				},
			}
		},
		computed: {
			...mapGetters({
				application: "initAppData",
			}),
			directDebitInformation: {
				get() {
					return _.get(this.application, "direct_debit_information.account_name")
						? _.get(this.application, "direct_debit_information")
						: this.defaultDirectDebitInformation
				},
				set(data) {
					Vue.set(this.application, "direct_debit_information", data)
				},
			},
		},
		methods: {
            cancelToken() {
				if (this.abortController) {
					this.abortController.abort()
				}
			},
			triggerSave() {
				this.cancelToken()
                this.abortController = new AbortController();
				this.save()
			},
			save() {
				axios
					.post(`/api/${this.$store.getters.appId}/direct-debit`, this.directDebitInformation, {
						signal: this.abortController.signal
					})
					.catch((err) => {
						if (!axios.isCancel(err)) {
							console.error(err)
						}
					})
			},
		},
		watch: {
			directDebitInformation: {
				handler(newVal, oldVal) {
					this.cancelToken()
					if (this.saveTimeout) clearTimeout(this.saveTimeout)
					this.saveTimeout = setTimeout(() => {
						this.$refs.directDebitInformation.validate((valid) => {
							if (valid) this.triggerSave()
						})
					}, this.saveDelay)
                    this.$store.dispatch("applicationValidation/validateData", {
                        section: "directDebit",
                        data: this.directDebitInformation
                    })
				},
				deep: true
			},
		},
	}
</script>

<style lang="scss" scoped>
</style>
